import { useEffect, useState } from "react";

const LandingAfterContent = () => {
  const COLORS = {
    primaryGreen: "#5ec250",
    lightGray: "#f0f0f0",
    border: "#e0e0e0",
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const styles = {
    container: {
      maxWidth: "1100px",
      margin: "0 auto",
      padding: isMobile ? "40px 16px" : "60px 20px",
      overflowX: "hidden",
      fontFamily: "'Plus Jakarta Sans', sans-serif",
    },

    title: {
      fontSize: isMobile ? "22px" : "26px",
      fontWeight: 500,
      lineHeight: 1.3,
      marginBottom: "20px",
      color: "#494040",
    },

    highlight: {
      color: COLORS.primaryGreen,
    },

    description: {
      fontSize: isMobile ? "16px" : "18px",
      lineHeight: 1.8,
      color: "#454343",
      marginBottom: "18px",
    },

    faqSection: {
      marginTop: "50px",
      background: "#f9f9f9",
      padding: "30px",
      borderRadius: "18px",
    },

    faqTitle: {
      fontSize: "24px",
      fontWeight: "600",
      marginBottom: "20px",
      textAlign: "center",
      color: "#333",
    },

    faqItem: {
      marginBottom: "20px",
      borderBottom: "1px solid #ddd",
      paddingBottom: "15px",
    },

    faqQuestion: {
      fontSize: "18px",
      fontWeight: "600",
      color: "#444",
      marginBottom: "8px",
    },

    faqAnswer: {
      fontSize: "16px",
      color: "#666",
      lineHeight: "1.6",
    },

    topSection: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
      gap: "40px",
      marginBottom: "50px",
    },

    topLeft: {
      textAlign: isMobile ? "center" : "left",
    },

    topRight: {
      display: "flex",
      justifyContent: isMobile ? "center" : "start",
    },

    imageWrapper: {
      position: "relative",
      maxWidth: "420px",
    },

    topImage: {
      width: "100%",
      borderRadius: "18px",
      objectFit: "cover",
      position: "relative",
      zIndex: 2,
    },

    tiltBg: {
      position: "absolute",
      top: "14px",
      width: "100%",
      height: "80%",
      background: "#e5e5e5",
      borderRadius: "18px",
      transform: "rotate(-4deg)",
      zIndex: 1,
    },

    bottomGrid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "2fr 3fr",
      gap: "28px",
      alignItems: "stretch",
    },

    greenCard: {
      background: COLORS.primaryGreen,
      color: "#fff",
      padding: "26px",
      borderRadius: "5px",
      fontSize: "15px",
      lineHeight: 1.5,
    },

    whiteCard: {
      background: "#fff",
      border: "1px solid #ddd",
      padding: "28px",
      borderRadius: "18px",
      height: "100%",
    },

    imageWrapperGrid: {
      gridColumn: isMobile ? "auto" : "2",
      height: "100%",
    },

    imageCard: {
      width: "100%",
      height: "100%",
      borderRadius: "18px",
      objectFit: "cover",
    },
  };

  const faqs = [
    { q: "What types of flats can I find in Trichy?", a: "You can choose from various options including 1BHK, 2BHK, 3BHK, and premium apartments, depending on your budget and lifestyle needs." },
    { q: "What amenities are typically available?", a: "Most apartments offer essential features like security, parking, lifts, and water supply. Premium projects may include gyms, clubhouses, and recreational spaces." },
    { q: "Is investing in flats in Trichy a good decision?", a: "Yes, Trichy is steadily growing in terms of infrastructure, education, and employment opportunities, making it a promising real estate market." },
    { q: "What should I verify before buying a flat?", a: "Always check legal approvals, builder credibility, project location, total cost, and surrounding infrastructure before making a decision." },
    { q: "Are home loans available for flats in Trichy?", a: "Yes, many banks and financial institutions provide home loan options with flexible terms based on your eligibility." },
    { q: "Is Trichy a good place to live?", a: "Trichy offers a balanced lifestyle with strong cultural roots, good infrastructure, and a peaceful environment, making it an ideal city for families." },
  ];

  return (
    <div style={styles.container}>
      {/* ---------- TOP ---------- */}
      <div style={styles.topSection}>
        <div style={styles.topLeft}>
          <h2 style={styles.title}>
            Premium Apartments for Sale in Trichy
          </h2>

          <p style={styles.description}>
            Explore high budget Apartments designed for families who value space, style, and modern living. At Mitha Homes, our thoughtfully crafted residences offer the perfect blend of comfort and functionality.<br /><br />
            These luxury apartments feature spacious living areas, well-designed bedrooms, contemporary kitchens, and elegant bathrooms—ideal for a comfortable and refined urban lifestyle.<br /><br />
            Strategically located in prime residential areas, our flats provide easy access to top schools, hospitals, shopping centers, and major road networks, ensuring convenience and a stress-free daily life.
          </p>
        </div>

        <div style={styles.topRight}>
          <div style={styles.imageWrapper}>
            <div style={styles.tiltBg}></div>
            <img
              src="https://mithahomes.com/backend/uploads/home/image1.png"
              alt="Luxury Apartments"
              style={styles.topImage}
            />
          </div>
        </div>
      </div>

      {/* ---------- BOTTOM GRID ---------- */}
      <div style={styles.bottomGrid}>
        <div style={styles.greenCard}>
          <h2 style={{ ...styles.title, color: "#fff" }}>
            Ready to Move Apartments for sale in Trichy
          </h2>
          <p>
            Discover a premium High budget Apartments with Mitha Homes, designed for those who seek elegance, comfort, and a modern lifestyle. Our residentials are crafted with top-grade materials, contemporary architecture, and high-end finishes to deliver a truly refined living experience.
            <br /><br />
            Each property is thoughtfully planned to offer spacious interiors, stylish designs, and premium amenities that enhance your everyday living.
            <br /><br />
            Located in prime residential areas, these apartments provide excellent connectivity to key parts of the city, along with easy access to schools, hospitals, and shopping destinations.
          </p>
        </div>

        <div style={styles.whiteCard}>
          <h2 style={styles.title}>Luxury Living Apartments with Modern Amenities</h2>
          <p style={styles.description}>
            At Mitha Homes, we offer a carefully curated selection of residential apartments located in some of the city’s most desirable neighborhoods. Whether you are planning to purchase your first home or move into a more spacious one, we provide options that suit different needs and budgets.<br /><br />
            Our portfolio includes well-designed 2 BHK and 3 BHK apartments, along with secure gated community homes that ensure a comfortable and modern lifestyle. Every project is developed to give you the perfect mix of convenience, accessibility, and quality living.
          </p>
        </div>

        <div style={styles.whiteCard}>
          <h2 style={styles.title}>Enjoy a Premium Lifestyle with Gated Community Apartments</h2>
          <p style={styles.description}>
            Step into a better way of living with our luxury apartments in Trichy, designed for safety, comfort, and peace of mind.<br /><br />
            These residential communities offer:
            • Round-the-clock security<br />
            • Beautifully maintained green spaces<br />
            • Organized parking facilities<br />
            • Family-friendly environment<br /><br />
            Living in a gated community not only enhances your lifestyle but also provides a secure and peaceful atmosphere for you and your loved ones.
          </p>
        </div>

        <div style={styles.imageWrapperGrid}>
          <img
            src="https://mithahomes.com/backend/uploads/home/image8.jpg"
            alt="Apartment Building"
            style={styles.imageCard}
          />
        </div>
      </div>

      {/* ---------- FAQ ---------- */}
      <div style={styles.faqSection}>
        <h2 style={styles.faqTitle}>FAQs – Buying Flats in Trichy</h2>
        {faqs.map((f, i) => (
          <div key={i} style={styles.faqItem}>
            <p style={styles.faqQuestion}>{f.q}</p>
            <p style={styles.faqAnswer}>{f.a}</p>
          </div>
        ))}
      </div>

      <div style={{ marginTop: '40px', textAlign: 'center', padding: '40px', background: '#333', color: '#fff', borderRadius: '18px' }}>
        <h2 style={{ color: '#fff' }}>Start Your Luxury Living  Journey with Mitha Homes</h2>
        <p style={{ fontSize: '18px', marginTop: '10px' }}>
          At Mitha Homes, we are committed to helping you find the perfect flat or apartment  in Trichy that matches your lifestyle and future goals.<br /><br />
          Get in touch with us today and take the first step toward owning your dream home.
        </p>
      </div>
    </div>
  );
};

export default LandingAfterContent;
